import {Modal} from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import React, {useEffect, useState} from 'react';
import {requestCandidates} from '@app/services/CandidateService';
import {ORDER_BY} from "@app/constants/Common";
import CandidateListTable, {CandidateListMode} from "@pages/candidate/list/CandidateListTable";
import DVTJCUVSearchCddJobSourceModeQuickSearch
    from "@pages/dvtjcuv/rundvtjcuv/search/searchcddjob/DVTJCUVSearchCddJobSourceModeQuickSearch";

export const DVTJCUVSearchCddJobSourceMoreReceiverTabs = {
    MAIN_LIST_TAB: {title: 'Main list', id: 'main-list-tab'},
    RECEIVER_WORKING_AT_CDD_EMPLOYER_TAB: {title: 'Các Receiver đang làm việc tại Current Employer của Cdd', id: 'receiver-working-at-cdd-employer-tab'},
    RECEIVER_WORKING_AT_PAST_CDD_EMPLOYER_TAB: {title: 'Các Receiver đang làm việc tại Past Employer của Cdd', id: 'receiver-working-at-past-cdd-employer-tab'},
    RECEIVER_IN_EMPLOYER_EXCLUDE_OTHER_TAB: {title: 'Các Receiver thuộc Employer bị loại trừ khác', id: 'receiver-in-employer-exclude-other-tab'},
    RECEIVER_EXCLUDE_OTHER_TAB: {title: 'Các Receiver bị loại trừ khác', id: 'receiver-exclude-other-tab'},
    RECEIVER_SENT_BRIEF_TAB: {title: 'Các Receiver đã gửi Brief Sent', id: 'receiver-sent-brief-tab'}
};

const DVTJCUVSearchCddJobSourceMoreReceiverModal = (props) => {
    const [candidates, setCandidates] = useState([]);
    const [allCandidateIds, setAllCandidateIds] = useState([]);
    const [selectedRectIds, setSelectedRecIds] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [searching, setSearching] = useState(false);
    const [currentTab, setCurrentTab] = useState(
        DVTJCUVSearchCddJobSourceMoreReceiverTabs.RECEIVER_SENT_BRIEF_TAB.id
    );
    const [searchConditions, setSearchConditions] = useState({});

    const {cddId, isShow, onAddReceivers, onClose} = props

    // const fetchCandidateList = async (canIds) => {
    //     const params = {
    //         order_by: ORDER_BY.DESC_UPDATE_DATE,
    //         search_conditions: searchConditions
    //     }
    //
    //     if (canIds && canIds.length > 0) {
    //         params.search_conditions.candidate_ids = canIds
    //     }
    //
    //     const res = await requestCandidates(params);
    //
    //     setCandidates(res.content.candidates);
    //     setAllCandidateIds(res.content.all_candidate_ids);
    //     setTotalCount(res.content.totalCount)
    //     setCurrentPage(res.content.page)
    //     setLoading(false)
    //     // setNumberPages(Math.floor(Number(res.content.totalCount) / DEFAULT_PAGE_SIZE) + 1);
    // }
    //
    // const fetchPipelines = async () => {
    //     const params = {
    //         search_conditions: {service_use_times: [], cdd_id: ''}
    //     }
    //
    //     if (strServiceUseTimes) {
    //         params.search_conditions.service_use_times = strServiceUseTimes.split(' ').map(item => item.trim()).filter(item => !!item);
    //     }
    //
    //     setLoading(true)
    //     const res = await requestGetDVTJCUVPipeLineList(params);
    //     if (res.sts_code === ResponseCode.SUCCESS) {
    //         const pipelines = res.content?.pipelines;
    //         const recIds = [];
    //         if (pipelines && pipelines.length > 0) {
    //             pipelines.forEach(item => {
    //                 if (item.cdd_receiver_id) {
    //                     recIds.push(item.cdd_receiver_id);
    //                 }
    //             })
    //         }
    //
    //         if (recIds.length > 0) {
    //             fetchCandidateList(recIds);
    //         } else {
    //             setCandidates([])
    //             setLoading(false)
    //         }
    //     }
    // }

    const fetchCandidateList = async (conditions) => {
        if (!conditions) {
            conditions = {}
        }
        conditions.cdd_id = cddId;

        // Mặc định set là curent tab
        if (!conditions.parent_tab) {
            conditions.parent_tab = currentTab;
        }
        conditions.search_cdd_source_more_receiver_mode = true;
        setSearchConditions(conditions)
        const params = {
            order_by: ORDER_BY.DESC_UPDATE_DATE,
            search_conditions: conditions,
            unlimited: true
        }

        setSearching(true)
        const res = await requestCandidates(params);
        setSearching(false)

        setCandidates(res.content.candidates);
        setAllCandidateIds(res.content.all_candidate_ids);
        setTotalCount(res.content.totalCount)
        setCurrentPage(res.content.page)
        // setNumberPages(Math.floor(Number(res.content.totalCount) / DEFAULT_PAGE_SIZE) + 1);
    }

    // useEffect(() => {
    //     fetchCandidateList({});
    // }, []);

    const onTabClicked = async (tabId) => {
        console.log(tabId);
        searchConditions.parent_tab = tabId
        setCurrentTab(tabId);
        await fetchCandidateList(searchConditions)
    };

    const activeTab = (tab) => {
        if (currentTab === tab) {
            return 'active'
        }
        return ''
    }

    const onReturnSelectedReceivers = (recIds) => {
      setSelectedRecIds(recIds);
    }

    const onSaveReceivers = () => {
      return onAddReceivers(selectedRectIds);
    }

    return (
        <>
            <Modal show={isShow}
                   fullscreen
                   onHide={onClose}
                   animation={false} style={{zIndex: 3004}}>
                <Modal.Header>
                    <Modal.Title>Chọn Receiver</Modal.Title>
                    <Button variant='secondary' onClick={onClose}>
                        Close
                    </Button>
                </Modal.Header>
                <Modal.Body>
                    <DVTJCUVSearchCddJobSourceModeQuickSearch
                        cddId={cddId}
                        onSearch={(condition) => fetchCandidateList(condition)}
                        searching={searching}
                    />
                    <div className='card card-default'>
                        <div className='card-header'>
                            <h3 className='card-title text-bold'>Danh sách Receivers</h3>
                            <div className={'card-tools'}>
                                <button type='button'
                                        className='btn btn-info btn-sm'
                                        disabled={selectedRectIds.length === 0}
                                        onClick={onSaveReceivers}>
                                    Lưu Receivers đã chọn
                                </button>
                            </div>
                        </div>
                        <div className='card-body p-0'>
                            <ul className='nav nav-tabs' role='tablist'>
                                {Object.values(DVTJCUVSearchCddJobSourceMoreReceiverTabs).map(tab => (
                                    <li className='nav-item' key={`saved-list-tab-item-${tab.id}`}>
                                        <a className={`nav-link ${activeTab(tab.id)}`} data-toggle='tab'
                                           href={'#' + tab.id}
                                           onClick={() => onTabClicked(tab.id)}>{tab.title}</a>
                                    </li>
                                ))}
                            </ul>
                            <div className='tab-content'>
                                {Object.values(DVTJCUVSearchCddJobSourceMoreReceiverTabs).map((tab, index) => {
                                    if (currentTab === tab.id) {
                                        return <div id={tab.id} className={`tab-pane ${activeTab(tab.id)}`}
                                                    style={{height: '83vh', overflow: 'auto'}}
                                                    key={`search-cdd-receiver-source-more-list-tab-content-${tab.id}`}>
                                            <CandidateListTable
                                                showBtnSelect
                                                candidates={candidates}
                                                allCandidateIds={allCandidateIds}
                                                mode={CandidateListMode.DVTJCUV_SEARCH_CDD_JOB_SOURCE_MORE_RECEIVER}
                                                totalCount={totalCount}
                                                onReturnSelectedItems={onReturnSelectedReceivers}
                                            />
                                        </div>
                                    }
                                    return "";
                                })}
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default DVTJCUVSearchCddJobSourceMoreReceiverModal;
